module.exports = __webpack_public_path__ + "img/eng-otz-man.91caeb5a.svg";